'use client';

import { FeedbackBoard } from '@/platform/feedback/FeedbackBoard';
import { useFirebaseUser } from '@/platform/lib/useFirebaseUser';

export function FeedbackPageClient() {
  const user = useFirebaseUser();
  return <FeedbackBoard isAuthenticated={!!user} />;
}
